var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 20.538 25.205"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_21788",
    "data-name": "Path 21788",
    d: "M22.737,9.388V6.768C22.737,3.036,19.387,0,15.269,0S7.8,3.036,7.8,6.768v2.62A3.377,3.377,0,0,0,5,12.71v9.121a3.378,3.378,0,0,0,3.374,3.374H22.163a3.378,3.378,0,0,0,3.374-3.374V12.709A3.377,3.377,0,0,0,22.737,9.388Zm-14-2.62c0-3.217,2.931-5.835,6.535-5.835S21.8,3.551,21.8,6.768V9.335H8.734Zm8.4,10.969a1.867,1.867,0,1,1-3.734,0v-2.8a1.867,1.867,0,1,1,3.734,0Z",
    transform: "translate(-5)",
    fill: "#504f4f"
  })));
};
export default __webpack_public_path__ + "static/media/locked.b392747c.svg";
export { SvgComponent as ReactComponent };